import React from "react";
import ReactDOM from "react-dom/client";
import { Store } from "@ludens-reklame/rubics-v3-sdk/store/types";
import { Section } from "@ludens-reklame/rubics-v3-sdk/section/types";
import { ErrorBoundary } from "./internal-components/error-boundary/error-boundary";
import { App } from "./app";
import Header from "./rubics-components/header/header";
import Footer from "./rubics-components/footer/footer";

const Text = React.lazy(() => import("./rubics-components/text/text"));
const Hero = React.lazy(() => import("./rubics-components/hero/hero"));
const Courses = React.lazy(() => import("./rubics-components/courses/courses"));
const InfoBox = React.lazy(
  () => import("./rubics-components/info-box/info-box"),
);
const CourseOverview = React.lazy(
  () => import("./rubics-components/course-overview/course-overview"),
);
const Image = React.lazy(() => import("./rubics-components/image/image"));
const AudioPlayer = React.lazy(
  () => import("./rubics-components/audio-player/audio-player"),
);
const Video = React.lazy(() => import("./rubics-components/video/video"));
const ImageCarousel = React.lazy(
  () => import("./rubics-components/image-carousel/image-carousel"),
);
const CourseContent = React.lazy(
  () => import("./rubics-components/course-content/course-content"),
);

const Assessment = React.lazy(
  () => import("./rubics-components/assessment/assessment"),
);

const MyPage = React.lazy(() => import("./rubics-components/my-page/my-page"));
const Login = React.lazy(() => import("./rubics-components/login/login"));
const Questions = React.lazy(() => import("./rubics-components/questions/questions"));



declare const _STORE: Store;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary root={true}>
      <App store={_STORE} renderer={renderSection} />
    </ErrorBoundary>
  </React.StrictMode>,
);

function renderSection(
  section: Section,
  children?: React.ReactNode,
): React.ReactNode {
  let suspend: boolean = true;
  let Component: React.ComponentType<any>;
  const domElem = document.getElementById(section.name);

  switch (section.component) {
    case "Header":
      Component = Header;
      suspend = false;
      break;
    case "Footer":
      Component = Footer;
      suspend = false;
      break;
    case "Text":
      Component = Text;
      break;
    case "Hero":
      Component = Hero;
      break;
    case "Courses":
      Component = Courses;
      break;
    case "InfoBox":
      Component = InfoBox;
      break;
    case "CourseOverview":
      Component = CourseOverview;
      break;
    case "Image":
      Component = Image;
      break;
    case "AudioPlayer":
      Component = AudioPlayer;
      break;
    case "Video":
      Component = Video;
      break;
    case "ImageCarousel":
      Component = ImageCarousel;
      break;
    case "CourseContent":
      Component = CourseContent;
      break;
    case "Assessment":
      Component = Assessment;
      break;
    case "MyPage":
      Component = MyPage;
      break;
    case "Login":
      Component = Login;
      break;
    case "Questions":
      Component = Questions;
      break;
    default:
      return null;
  }

  if (!suspend) {
    return (
      <ErrorBoundary>
        <Component {...section.props}>{children}</Component>
      </ErrorBoundary>
    );
  }

  return (
    <React.Suspense
      fallback={
        domElem ? (
          <div dangerouslySetInnerHTML={{ __html: domElem.innerHTML }} />
        ) : null
      }
    >
      <ErrorBoundary>
        <Component {...section.props}>{children}</Component>
      </ErrorBoundary>
    </React.Suspense>
  );
}
